import './App.css';
import type { ComponentType, ReactElement, ReactNode } from 'react';

import { ConfigContextProvider } from './contexts/config/config.provider';
import { MasterContextProvider } from './contexts/master/master.provider';
import { UserContextProvider } from './contexts/user/user.provider';
import Router from './routers';

type Provider = ComponentType<{ children?: ReactNode }>;

const appProviders: Provider[] = [
  ConfigContextProvider,
  MasterContextProvider,
  UserContextProvider,
];

function App() {
  const root: ReactElement = (
    <div className="App">
      <Router />
    </div>
  );

  return appProviders.reduceRight<ReactElement>(
    (children, Provider) => <Provider>{children}</Provider>,
    root
  );
}

export default App;
